import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'

import { ButtonComponent } from '../../components/button/button.component'

@Component({
  selector: 'app-unauthorized',
  imports: [TranslatePipe, ButtonComponent, SvgIconComponent],
  templateUrl: './unauthorized.component.html',
})
export class UnauthorizedComponent {
  public constructor(private readonly router: Router) {}

  public navigateToHome(): void {
    this.router.navigate(['/'])
  }
}
